<div class="loader">
  <div class="container">
    <mat-spinner aria-label="loader"></mat-spinner>
    <span>{{ text }}</span>
  </div>
</div>
